<template>
    <div class="page">
        <div class="organization">
            <div class="search">
                <!-- <el-input
          prop="organizationKeyword"
          v-model="organizationKeyword"
          @keyup.enter.native="getDepartmentList"
          placeholder="请输入搜索关键字"
          size="small"
          clearable
        ></el-input> -->
            </div>

            <el-tree default-expand-all :data="departmentList" :props="treeProps" @node-click="handleNodeClick" size="mini">
                <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                    <Icon v-if="data.parentId == '0'">
                        <Organization24Filled />
                    </Icon>
                    <Icon v-if="data.parentId == '1'">
                        <PeopleCommunity24Filled />
                    </Icon>
                    <Icon v-if="data.parentId == '2'">
                        <Person24Filled />
                    </Icon>
                    <span class="ml-1">{{ node.label }}</span>
                </div>
            </el-tree>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1" class="overflow-auto">
            <div>
                <el-form
                    v-if="send"
                    class="query-form"
                    :model="queryForm"
                    ref="queryForm"
                    :rules="queryFormRules"
                    label-width="70"
                    :inline="true"
                    size="normal"
                    @submit.native.prevent
                >
                    <el-form-item label="用户账号">
                        <el-input size="small" v-model="queryForm.userName" placeholder="账号" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input size="small" v-model="queryForm.userMobile" placeholder="手机号码" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="用户昵称">
                        <el-input size="small" v-model="queryForm.userNickname" placeholder="昵称" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="真实姓名">
                        <el-input size="small" v-model="queryForm.userRealname" placeholder="真实姓名" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="用户等级">
                        <el-select size="small" clearable v-model="queryForm.gradeId" placeholder="请选择" style="width: 200px">
                            <el-option v-for="role in mppGradeList" :key="role.id" :label="role.gradeName" :value="role.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="checkState = 'check'">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="checkState = 'reset'">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <UserListTable
                :data="this.data"
                @send="getData"
                :checkState="checkState"
                :queryForm="queryForm"
                :departmentList="departmentList"
                :postList="postList"
                :roleList="roleList"
                :mppGradeList="mppGradeList"
                @resetCheckState="resetCheckState"
            />
        </div>
    </div>
</template>

<script>
import { getDepartmentList } from '@/api/dept.js';
import { getPostList } from '@/api/post.js';
import { getRoleList } from '@/api/role.js';
import { PeopleCommunity24Filled, Person24Filled, Organization24Filled } from '@v2icons/fluent';
import UserListTable from '@/components/organization/UserListTable.vue';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        UserListTable,
        Person24Filled,
        Organization24Filled,
        PeopleCommunity24Filled
    },
    data() {
        return {
            departmentList: [],
            postList: [],
            roleList: [],
            userList: [],
            checkState: '',
            organizationKeyword: '',
            queryForm: {
                deptId: '',
                userName: '',
                userNickname: '',
                gradeId: '',
                userMobile: '',
                userRealname: '',
                gradeName: '' //等级名称
            },
            deptName: '',
            queryFormRules: {},
            data: '',
            send: '',
            treeProps: {
                children: 'children',
                label: 'deptName'
            },
            pageSize: 10,
            currentPage: 1,
            mppGradeList: [],
            totalNum: 0
        };
    },
    created() {
        this.getDepartmentList();
        this.getPostList();
        this.getRoleList();
        this.getMppGradeList();
    },
    watch: {
        organizationKeyword: function (val) {
            this.organizationKeyword = val;
            getDepartmentList({ deptName: this.organizationKeyword }).then((res) => {
                if (res.success) {
                    this.departmentList = res.treeData;
                }
            });
        }
    },
    methods: {
        getMppGradeList() {
            this.loading = true;
            console.log(this.queryForm);
            get(`/mpp/grade/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppGradeList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },

        getData(data) {
            this.send = data;
        },
        handleNodeClick(data) {
            this.checkState = 'check';
            this.queryForm.deptId = data.id;
        },
        getDepartmentList() {
            getDepartmentList({ deptName: this.organizationKeyword }).then((res) => {
                if (res.success) {
                    this.departmentList = res.treeData;
                }
            });
        },
        getPostList() {
            getPostList({ pageNum: 1, pageSize: 10 }).then((res) => {
                if (res.success) {
                    this.postList = res.page.list;
                }
            });
        },
        getRoleList() {
            getRoleList({ pageNum: 1, pageSize: 20 }).then((res) => {
                if (res.success) {
                    this.roleList = res.page.list;
                }
            });
        },
        search() {
            this.deptName = this.organizationKeyword;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {
                    deptId: '',
                    userName: '',
                    userNickname: '',
                    gradeId: '',
                    userMobile: '',
                    userRealname: '',
                };
                this.organizationKeyword = '';
            }
            this.checkState = '';
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
::v-deep .el-tree-node__content {
    height: 25px !important;
    font-size: 13px !important;
}
.page {
    display: flex;
    flex-direction: row;
    .organization {
        height: 100%;
        width: 200px;
        margin-right: 15px;
        padding: 10px;
        background-color: #fff;
        .search {
            margin: 10px 0;
        }
    }
}
// .query-form {
//     padding-left: 0;
// }
</style>
